import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

/**
 * Peach announcement ticker bar (Figma Announcement Bar).
 */
export function OnyxAnnouncementBar({
  message = '',
  className = '',
}) {
  if (!message) return null;
  return (
    <div
      className={['onyx-announcement-bar', className].filter(Boolean).join(' ')}
      data-testid="onyx-announcement-bar"
      role="status"
    >
      <Typography variant="label" component="p" className="onyx-announcement-bar__text">
        {message}
      </Typography>
    </div>
  );
}

OnyxAnnouncementBar.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
};
